<template lang="html">

  <div class="contenedor-popup-cups row-center">
    <div class="info-pop column-center">
      <a @click="$emit('close')" class="cerrar">✕</a>
      <p>
        <strong>¿Qué es el CUPS?</strong>
        <template v-if="type == 'electric'">
        El CUPS es un código numérico de entre 20 y 22 caracteres que encontrarás en tu factura de la luz.
        Este número identifica el punto de suministro de energía de tu vivienda y con él podemos averiguar tu potencia,
        consumo y tarifa de acceso.
      </template>
      <template v-if="type == 'gas'">
        El CUPS es un código numérico de entre 20 y 22 caracteres que encontrarás en tu factura del gas.
        Este número identifica el punto de suministro de gas de tu vivienda y con él podemos averiguar tu tarifa de acceso.
      </template>
      </p>
      <img src="/static/img/cups.webp" alt="Ejemplo de cups" width="250">
      <div class="dudas">
        <p>Si tienes dudas, puedes llamarnos <a href="tel:900848402" @click="trackPhoneClick">900 848 402</a></p>
      </div>
    </div>
  </div>

</template>

<script lang="js">
  export default {
    name: 'cups-popup-info',
    props: ['type'],
    methods: {
    trackPhoneClick() {
      this.gtag_report_conversion();
    },
    gtag_report_conversion(url) {
      const callback = function () {
        if (typeof url !== 'undefined') {
          window.location = url;
        }
      };
      if (typeof gtag !== 'undefined') {
        gtag('event', 'conversion', {
          'send_to': 'AW-692816998/WlrfCIOgwfYaEOaYrsoC',
          'value': 1.0,
          'currency': 'EUR',
          'event_callback': callback
        });
      }
      return false;
    }
  }
  }
</script>

<style scoped lang="scss">
  @import '@/assets/css/colors.scss';

  .contenedor-popup-cups {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 10;
    background: rgba(0, 0, 0, .4);
  }

  .info-pop {
    position: relative;
    background: $dark;
    max-width: 450px;
    width: 100%;
    color: white;
    padding: 15px;
    z-index: 10;
    border-radius: 5px;

    .cerrar {
      position: absolute;
      right: 10px;
      top: 10px;
    }

    >p {
      color: white;
      max-width: 100%;
      font-size: 14px;
      font-weight: 400;

      strong {
        font-weight: bold;
        width: 100%;
        font-size: 16px;
        display: inline-block;
      }
    }

    .dudas {
      width: 100%;
      margin-top: 10px;

      p {
        color: white;
        font-size: 14px;
        width: 100%;
        font-weight: 400;
        margin-bottom: 0;

        a {
          text-decoration: underline;
        }
      }
    }

    img {
      max-width: 100%;
      width: 100%;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/parts/cups-popup-info.vue